"use client"

import { createFileRoute } from '@tanstack/react-router'
import { CompactFileViewer } from '@/src/components/manage/views/CompactFileViewer'

export const Route = createFileRoute('/file/$shareId')({
  component: FileSharePage,
})

function FileSharePage() {
  const { shareId } = Route.useParams()
  return (
    <main className="container mx-auto px-0 sm:px-4">
      <CompactFileViewer shareId={shareId} showUploadedBy={false} />
    </main>
  )
}
